


























































import Vue from "vue";
import TableLayout from "@/layouts/TableLayout.vue";
import { Header } from "@/components/MyTable.vue";
import { mapState, mapGetters, mapActions } from "vuex";
import Edit from "@/components/PrjAlert/Edit.vue";

const PrjAlertHeaders: Header[] = [
  { title: "组件名" },
  { title: "接收目标" },
  { title: "目标类型" },
  { title: "目标描述" },
  { title: "创建者" },
  { title: "创建时间", width: 180 },
  { title: "操作", width: 100 }
];
const TargetTypeOption = [
  {
    label: "钉钉",
    value: "DINGTALK"
  },
  {
    label: "邮箱",
    value: "EMAIL"
  },
  {
    label: "短信",
    value: "SMS"
  }
];

export default Vue.extend({
  name: "PrjAlert",
  components: { TableLayout, Edit },
  props: { projectId: { type: String }, tenantId: { type: String } },
  data() {
    return {
      disabled: false,
      PrjAlertHeaders
    };
  },
  computed: {
    ...mapState("PrjAlert", ["total", "hasNext", "pageNum", "loading"]),
    ...mapGetters("PrjAlert", ["tableData"])
  },
  mounted() {
    this.getTable();
  },
  methods: {
    ...mapActions("PrjAlert", ["getData", "pageTurn", "clear", "delete"]),
    create(data: any) {
      (this.$refs.edit as any).show(data);
    },
    getTable() {
      this.getData({
        url: `/alertrule/${this.projectId}`
      });
    },
    turnPage(page: number) {
      this.disabled = true;
      this.pageTurn({ page }).finally(() => {
        this.disabled = false;
      });
    },
    handleCommand(type: string, data: any) {
      switch (type) {
        case "edit":
          this.create(data);
          break;

        case "delete":
          this.del(data.id);
          break;
      }
    },
    del(id: string) {
      this.$confirms({ title: `删除告警规则` }).then(() => {
        this.delete({ url: `/alertrule/${id}` }).then(() => {
          this.$message.success("告警规则删除成功");
        });
      });
    },
    getTypeName(type: string) {
      const data = TargetTypeOption.find(item => item.value === type);
      if (data) {
        return data.label;
      }
    }
  }
});
